import api from './api';
import { NextApiRequest, NextApiResponse } from 'next';
import { APIProxy } from 'ui/services/api-proxy';
import { extractTokensFromCookies } from 'ui/lib/cookies';

const API_GATEWAY_URL_PARAMETER = process.env.API_GATEWAY_URL_PARAMETER;

const getListProvince = (params) => {
  return api.get(
    `parameter/v1/province${params && `?${params.toString()}`}`,
    {},
    false,
    false,
    false
  );
};

const getListCity = (isoCode, params) => {
  return api.get(
    `parameter/v1/province/${isoCode}${params && `?${params.toString()}`}`,
    {},
    false,
    false,
    false
  );
};

const getCityByCityIsoCode = (cityIsoCode) => {
  return api.post(
    `parameter/v1/city`,
    null,
    {
      filters: [
        {
          key: 'isocode',
          operator: 'EQUALS',
          fieldType: 'STRING',
          value: cityIsoCode,
        },
      ],
      page: 0,
      size: 1,
    },
    false,
    false
  );
};

const getCategoryType = (categoryType, isUseGatewayAPI?) => {
  return api.get(
    `parameter/v1/category/${categoryType}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_PARAMETER } : {},
    false,
    false,
    false
  );
};

const getListBranch = (payload) => {
  return api.post(`parameter/v1/branch`, null, payload);
};

const getListBranchIsoCode = (code: string, params: URLSearchParams | null = null) => {
  return api.get(
    `parameter/v1/branch/get-branch-list/city/${code}${params && `?${params.toString()}`}`,
    {},
    false,
    false,
    false
  );
};

const getLocationDistance = (payload) => {
  return api.post(`parameter/v1/location/distance`, null, payload);
};

const getSimulationCredit = (type, isUseGatewayAPI?) => {
  return api.get(
    `parameter/v1/parameter/get-config/${type}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_PARAMETER } : {},
    false,
    false,
    false
  );
};

const getSitemap = () => {
  return api.get(`parameter/v1/sitemap`, {}, false, false, false);
};

const getSitemapByName = (sitemapName: string) => {
  return api.get(`parameter/v1/sitemap/${sitemapName}`, {}, false, false, false);
};

const getMinimumDeliveryFee = () => {
  return api.get('parameter/v1/parameter/get-config/minimum_delivery_fee', {}, false, false, false);
};

const getCmsFormByType = (src, formType, formFormat, city = '') => {
  return api.get(
    `parameter/v1/cms-form?formType=${formType}&formatForm=${formFormat}&src=${src}${city ? `&city=${city}` : ''}`,
    false,
    false,
    false
  );
};

const submitLeadsAPIFunction = async (req: NextApiRequest, res: NextApiResponse) => {
  try {
    if (req.method !== 'POST') {
      return res.status(405).json({ error: 'Method Not Allowed' });
    }
    const accessToken = req?.cookies?.['access-token'];
    const apiProxy = new APIProxy(req, res);
    const result = await apiProxy.makeRequest({
      method: 'POST',
      ...(req.body?.formId && { params: { formId: req.body?.formId } }),
      url: `/customer/v1/submit-leads`,
      headers: {
        ...(accessToken && { Authorization: 'Bearer ' + accessToken }),
        'X-Captcha': req.body?.data?.recaptchaToken || null,
      },
      data: req.body,
    });
    if (result?.status === 200) {
      return res.status(200).json(result?.data);
    } else {
      const errorStatus = result?.status || (result as any)?.response?.status;
      const errorData = result?.data || (result as any)?.response?.data;
      return res.status(errorStatus || 500).json(errorData || { error: 'Internal Server Error' });
    }
  } catch (error) {
    return res
      .status(error?.response?.data?.status ?? 500)
      .json(error?.response?.data ?? { error: 'Internal Server Error' });
  }
};

const getBrancDetailByBranchCode = (branchCode) => {
  return api.post(
    `parameter/v1/branch`,
    null,
    {
      filters: [
        {
          key: 'branchName',
          operator: 'EQUALS',
          fieldType: 'STRING',
          value: branchCode,
        },
      ],
      page: 0,
      size: 1,
    },
    false,
    false
  );
};

const getLoyaltyTierContent = () => {
  return api.get(`parameter/v1/loyalty-tier/content`);
};

const getLoyaltyTierBenefits = () => {
  return api.get(`parameter/v1/loyalty-tier/benefit`);
};

const getLoyaltyTierArticle = () => {
  return api.get(`parameter/v1/loyalty-tier/article`);
};

const getTestDrivePDP = (code) => {
  return api.get(`parameter/v1/test-drive/content/pdp/${code}`, {}, false, false, false);
};

const getTestDriveDetail = (code) => {
  return api.get(`parameter/v1/test-drive/content/detail/${code}`, {}, false, false, false);
};

const getTestDriveUsedCarDetail = (code) => {
  return api.get(
    `parameter/v1/used-car/detail/tes-drive-content?code=${code}`,
    {},
    false,
    false,
    false
  );
};

export default {
  getListProvince,
  getListCity,
  getListBranch,
  getCategoryType,
  getListBranchIsoCode,
  getLocationDistance,
  getSimulationCredit,
  getSitemap,
  getSitemapByName,
  getMinimumDeliveryFee,
  getCityByCityIsoCode,
  getCmsFormByType,
  getBrancDetailByBranchCode,
  submitLeadsAPIFunction,
  getLoyaltyTierContent,
  getLoyaltyTierBenefits,
  getLoyaltyTierArticle,
  getTestDrivePDP,
  getTestDriveDetail,
  getTestDriveUsedCarDetail,
};
